import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import TableHeaderCell from 'components/atoms/TableHeaderCell'

const styles = theme => ({
  root: {
    width: '100%',
    display: 'flex',
    paddingBottom: theme.spacing(2),
    justifyContent: 'space-between',
    borderBottom: `1px solid ${theme.palette.background.medium}`,
  },
})

const TableHeader = ({
  ascending,
  classes,
  columns,
  disabled,
  selectedColumn,
  onSortClick,
  ...cellProps
}) => {
  return (
    <div className={classes.root}>
      {columns.map((column, index) => {
        const isActive = selectedColumn === column.field
        const selectable = column.selectable !== false && !disabled

        return (
          <TableHeaderCell
            key={index}
            column={column}
            isActive={isActive}
            ascending={ascending}
            onClick={onSortClick}
            selectable={selectable}
            {...cellProps}
          />
        )
      })}
    </div>
  )
}

TableHeader.propTypes = {
  columns: PropTypes.array,
  disabled: PropTypes.bool,
  classes: PropTypes.object,
  ascending: PropTypes.bool,
  onSortClick: PropTypes.func,
  selectedColumn: PropTypes.string,
}

export default withStyles(styles)(TableHeader)



// WEBPACK FOOTER //
// ./src/components/molecules/TableHeader.js